import { Button, Form, Input, message, Modal, Select } from "antd";
import { useTranslation } from "react-i18next";
import { DownOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import "../Styles/AddProducts.css";
import React, { useEffect, useState } from "react";
import { apiClient } from "../Api/AllApi";

const UpdateUnit = ({ storeUnits }) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [product, setProduct] = useState({});
  const [units, setUnits] = useState([]);
  const [parentId, setParentId] = useState(null);

  // Find product in storeUnits or fetch it directly
  useEffect(() => {
    if (Array.isArray(storeUnits) && storeUnits.length > 0) {
      const foundProduct = storeUnits.find((item) => item.id === parseInt(id));
      if (foundProduct) {
        setProduct(foundProduct);
        // Set parent ID if it exists
        if (foundProduct.parent_id) {
          setParentId(foundProduct.parent_id);
        }
      } else {
        // If not found in storeUnits, fetch directly
        fetchUnitDirectly();
      }
    } else {
      fetchUnitDirectly();
    }
  }, [storeUnits, id]);  // Fetch unit directly from API if not available in storeUnits
  const fetchUnitDirectly = () => {
    apiClient.get(`/units/${id}`)
      .then(response => {
        const data = response.data;
        if (data) {
          setProduct(data);
          if (data.parent_id) {
            setParentId(data.parent_id);
          }
        }
      })
      .catch(error => {
        console.error('Error fetching unit:', error);
        // Only show error message for actual failures, not when unit doesn't exist
        if (error.response && error.response.status === 404) {
        } else {
          message.error(t('Failed to load unit data'));
        }
      });
  };  // Fetch available units for parent selection
  useEffect(() => {
    apiClient.get("/units")
      .then((response) => {
        const data = response.data;
        if (Array.isArray(data)) {
          // Filter out the current unit to prevent selecting itself as parent
          const filteredUnits = data.filter(unit => unit.id !== parseInt(id));
          setUnits(filteredUnits);
        } else {
          setUnits([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching units:", error);
        setUnits([]); // Set empty array so the component doesn't break
        // Only show error for actual failures, not for empty responses
        if (!(error.response && error.response.status === 404)) {
          message.error(t("Failed to fetch units for parent selection"));
        }
      });
  }, [id, t]);

  const [form] = Form.useForm();
  //todo this is Modal  Name
  const [isModalOpenNew, setIsModalOpenNew] = useState(false);

  const handleCancelNew = () => {
    setIsModalOpenNew(false);
  };
  const showModalNew = () => {
    setIsModalOpenNew(true);
  };

  const handleOkNew = () => {
    setIsModalOpenNew(false);
  };  //! End modal
  //todo this is get API for User
  // const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (product && product.name) {
      try {
        let nameObj = {};
        if (typeof product.name === "string") {
          try {
            nameObj = JSON.parse(product.name);
          } catch (error) {
            console.error("Invalid JSON format in product.name:", error);
            nameObj = {}; // Fallback to an empty object if JSON parsing fails
          }
        } else if (typeof product.name === "object" && product.name !== null) {
          nameObj = product.name;
        }

        // Handle possible null/undefined
        form.setFieldsValue({
          TitleKurdish: nameObj.en || "",
          TitleArabic: nameObj.ar || "",
          parent_id: product.parent_id || null,
        });
      } catch (error) {
        console.error("Error parsing product name or description:", error);
      }
    }
  }, [product, form]);  //todo update user
  const onFinish = async (values) => {
    try {
      const name = {
        en: form.getFieldValue("TitleKurdish"),
        ar: form.getFieldValue("TitleArabic"),
      };

      const updatedValues = {
        ...values,
        sku: values.sku,
        // stock: values.stock,
        name: name,
      };

      // Add parent_id if selected
      if (values.parent_id) {
        updatedValues.parent_id = values.parent_id;
      }

      const response = await apiClient.put(
        `/units/${id}`,
        updatedValues
      );

      if (response.status === 200) {
        message.success("Successfully updated");
        window.location.href = "/GetUnit";
      }
    } catch (error) {
      console.error("Error updating unit:", error);
      message.error("Failed to update");
    }
  };

  const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 16,
    },
  };
  const onFinishFailed = () => {
    // console.log("Failed:", errorInfo);
    message.error("Error");
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px", direction: "rtl" }}>
      <h1 style={{ fontSize: "24px", marginBottom: "20px" }}>
        {t("unit update")}{" "}
      </h1>

      {/* //! end image ================================= */}      <Form
        form={form}
        {...layout}
        style={{
          fontSize: "18px", // Global font size for the entire form
        }}
        labelCol={{ span: 6 }} // Adjusts label width
        wrapperCol={{ span: 16 }} // Adjusts input width
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}      >
        {/* //TODO: name products ============== */}
        <Form.Item name="name" label={t("name")}>
          <Button
            type="text"
            style={{
              border: "1px solid #ccc",
              borderRadius: "4px",
              width: "70%",
              fontSize: "16px",
              textAlign: "center",
              display: "inline-block",

              backgroundColor: "#f0f0f0", // Change background color
              color: "#333", // Change text color
              fontWeight: "bold", // Make text bold
              boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.1)", // Add a box shadow
            }}
            onClick={showModalNew}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {t("enter unit")}
              <DownOutlined />
            </div>
          </Button>

          <Modal
            style={{
              direction: "rtl",
            }}
            title={t("enter unit")}
            open={isModalOpenNew}
            onOk={handleOkNew}
            onCancel={handleCancelNew}
          >            <Form.Item name="TitleKurdish" label={t("كوردى")}>
              <Input />
            </Form.Item>
            <Form.Item name="TitleArabic" label={t("عربي")}>
              <Input />
            </Form.Item>          </Modal>
        </Form.Item>
        {/* Parent Unit Selector */}        <Form.Item name="parent_id" label={t("یەکەی سەرەکی")}>
          <Select
            placeholder={t("Select parent unit")}
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            onChange={(value) => setParentId(value)}
            allowClear
          >
            {units && units.map((unit) => (
              <Select.Option key={unit.id} value={unit.id}>
                {unit.name && typeof unit.name === 'string' ? JSON.parse(unit.name).en : ''}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        {/* //! end image ================================= */}
        {/* <Form.Item
          name="TitleKurdish"
          label={
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>اسم</span>
          }
        >
          <Input
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            placeholder="أدخل رقمك"
          />
        </Form.Item> */}

        {/* //! ----------------------------------------------- */}

        <Form.Item label=".">
          <Button
            type="primary"
            htmlType="submit"
            style={{
              backgroundColor: "blue",
              borderColor: "blue",
              fontSize: "16px",
            }}
          >
            {t("submit")}
          </Button>
          <span style={{ margin: "0 8px" }}></span>
          <Button
            style={{
              backgroundColor: "red",
              borderColor: "red",
              fontSize: "16px",
            }}
            type="primary"
            danger
            onClick={() => (window.location.href = "/GetUnit")}
          >
            {t("cancel")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default UpdateUnit;